import { render } from "./SignUpEdit.vue?vue&type=template&id=12709c87"
import script from "./SignUpEdit.vue?vue&type=script&lang=js"
export * from "./SignUpEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__